import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { get, put } from './inner-store'
import { INNER_STORE } from './constants'
import qs from 'qs'

export type iLogout = () => Promise<AxiosResponse>

const logout: iLogout = () => {
  const data = qs.stringify({
    client_id: get(INNER_STORE.client_id),
    refresh_token: get(INNER_STORE.auth).refresh_token,
  })

  const config: AxiosRequestConfig = {
    method: 'post',
    url: get(INNER_STORE.authServerLogoutUri),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  }

  put(INNER_STORE.auth, {
    isAuthenticated: false,
  })

  const autoRefresh = get(INNER_STORE.autoRefresh)
  const cancelRefreshOnTime = get(INNER_STORE.cancelRefreshOnTime)

  if (autoRefresh && cancelRefreshOnTime !== undefined)
    cancelRefreshOnTime()

  return axios.request(config)
}

export { logout }
